import React, {useEffect, useMemo} from 'react'
import {components} from 'react-select'
import useList from '../../../../hooks/useList'
import pluralize from '../../../../helpers/pluralize'
import Select from '../../../../shared/Select'
import Checkbox from '../../../../shared/Checkbox'

const AttributesSelector = ({attributes, attributeName, onChange, getLabelOption}) => {
    const {
        filteredList,
        onFilterList,
        selected,
        onRemoveItemFromSelected,
        onAddItemToSelected,
        isSelected,
        isSelectedAll,
        selectAll,
        unSelectAll,
    } = useList({
        initialList: attributes,
        defaultSelected: attributes,
    })

    useEffect(() => {
        onChange?.(selected)
    }, [selected])

    const handleOptionClick = (option) => {
        if (isSelected(option.id)) {
            onRemoveItemFromSelected(option.id)
        } else {
            onAddItemToSelected(option)
        }
    }

    const handleSelectAll = () => {
        if (isSelectedAll) {
            unSelectAll()
        } else {
            selectAll()
        }
    }
    const handleSearch = (searchValue) => {
        const filterByLabel = (option) => {
            return option.label.toLowerCase().includes(searchValue)
        }
        const search = onFilterList(filterByLabel)
        search()
    }

    const renderOption = ({data, onClick, ...rest}) => {
        const option = data
        const isHeader = option?.isHeader

        if (isHeader) {
            return (
                <div
                    {...rest.innerProps}
                    style={{
                        padding: '8px 4px',
                        fontWeight: 'bold',
                        cursor: 'default',
                    }}
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleSelectAll()
                    }}
                >
                    <Checkbox
                        checked={isSelectedAll}
                        indeterminate={selected.length > 0 && !isSelectedAll}
                        label={option.label}
                    />
                </div>
            )
        }

        return (
            <components.Option
                {...rest}
                innerProps={{
                    ...rest.innerProps,
                    onClick: (e) => {
                        handleOptionClick(option)
                    },
                }}
            >
                <Checkbox
                    label={getLabelOption ? getLabelOption(option) : option.label}
                    checked={isSelected(option.id)}
                />
            </components.Option>
        )
    }

    const headerOption = {
        value: '__header__',
        label: `Select all (${selected.length}/${filteredList.length})`,
        isHeader: true,
    }

    const actualOptions = useMemo(
        () => (filteredList.length > 0 ? [headerOption, ...filteredList] : filteredList),
        [filteredList, selected],
    )

    return (
        <Select
            placeholder={`${pluralize(selected.length, attributeName, 's')} selected`}
            options={actualOptions}
            components={{
                Option: renderOption,
            }}
            filterOption={false}
            onInputChange={handleSearch}
            styles={{
                control: (base) => ({
                    ...base,
                    minWidth: '8ch',
                    borderColor: '#DEE2E6',
                }),
                container: (base) => ({
                    ...base,
                    width: '100%',
                }),
            }}
        />
    )
}

export default AttributesSelector
